module.exports = __webpack_public_path__ + "static/media/ATM.c7317979.svg";